import { HUMBLE } from "@/constants/testIds";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid={HUMBLE.footer}
      className="relative overflow-hidden bg-earth text-cream/80"
    >
      <div
        aria-hidden
        className="pointer-events-none absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-cream/25 to-transparent"
      />
      <div className="mx-auto flex w-full max-w-[1400px] flex-col items-start gap-10 px-6 py-14 md:flex-row md:items-end md:justify-between md:px-12 md:py-16">
        <div>
          <div className="font-display italic text-2xl md:text-3xl text-cream">
            Humble Roots
          </div>
          <div className="mt-2 font-body text-sm text-cream/60">
            A calm, simple way to keep the homestead you love.
          </div>
        </div>
        <div className="flex flex-col items-start gap-3 md:items-end">
          <div
            data-testid={HUMBLE.soliDeoGloria}
            className="font-display italic text-lg text-gold"
          >
            soli Deo gloria
          </div>
          <div className="font-body text-xs uppercase tracking-[0.35em] text-cream/45">
            &copy; {year} — Made slowly, in Arkansas.
          </div>
        </div>
      </div>
    </footer>
  );
}
